// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function broadcastMessageNotificationPreferenceSettingV5_decode($$enum) {
  if ($$enum === "ALL_CATEGORIES" || $$enum === "NO_CATEGORIES") {
    return $$enum;
  }
}

let broadcastMessageNotificationPreferenceSettingV5_fromString = broadcastMessageNotificationPreferenceSettingV5_decode;

let Utils = {
  broadcastMessageNotificationPreferenceSettingV5_decode: broadcastMessageNotificationPreferenceSettingV5_decode,
  broadcastMessageNotificationPreferenceSettingV5_fromString: broadcastMessageNotificationPreferenceSettingV5_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NotificationSettingsBroadcastMessages_notificationSetting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nodeId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BroadcastMessageNotificationSettingV5",
      "kind": "LinkedField",
      "name": "broadcastMessages",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "setting",
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNotificationSettingsV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
